import { render, staticRenderFns } from "./ContentWeekGantt.vue?vue&type=template&id=379e3af8&"
import script from "./ContentWeekGantt.vue?vue&type=script&lang=js&"
export * from "./ContentWeekGantt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports